/**
	 * @author Francis Stalin
	 * @component SignupFormDirective
	 * @version 1.1
	 *
	 * This directive is used to show password strength.
	 *
	 * Usage:
	 		<wow-password-strength></wow-password-strength>
*
**/
module.exports = function (PasswordStrengthService) {
    return {
        restrict: 'E',
        template: require('./password-strength-template.html').trim(),
        scope: {
            password: '=password',
            goal: '@?' // Goal to achieve in entropy calculation. Default: 96
        },
        link(scope) {

            scope.passwordStrength = 0;
            scope.passwordStrengthText = '';
            scope.goal = 96;

            scope.calculateStrength = function (password) {
                scope.passwordStrength = PasswordStrengthService.getPasswordStrength(password, scope.goal);
                switch (Math.ceil(scope.passwordStrength / 33)) {
                    case 0:
                    case 1:
                        scope.passwordStrengthText = 'Weak';
                        break;
                    case 2:
                        scope.passwordStrengthText = 'Normal';
                        break;
                    default:
                        scope.passwordStrengthText = 'Strong';
                }
            };

            scope.delay = (function () {
                let timer = 0;
                return function (callback, ms) {
                    clearTimeout(timer);
                    timer = setTimeout(callback, ms);
                };
            })();

            scope.$watch('password', function (value) {
                if (value) {
                   scope.calculateStrength(value);
                } else {
                    scope.passwordStrength = 0;
                    scope.passwordStrengthText = 'Weak';
                }
            });

            //Initialize password stength service
            PasswordStrengthService.init();
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/password-strength-directive.js
 **/